<template>
  <div class="flex flex-col w-full">
    <!-- Layout responsivo: una columna por defecto, dos columnas en md -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
      <!-- Columna izquierda -->
      <div class="flex flex-col space-y-4">

        <expandable-panel :item="_GetOptionsConfig('config_pictogram_specifications')">
          <div class="text-sm text-gray-700">
            <div class="flex flex-col space-y-3">
              <b-field :label="$t('code')">
                <b-input v-model="form.code" placeholder="Codigo del pictograma" disabled></b-input>
              </b-field>
              <b-field :label="$t('name')">
                <b-input v-model="form.name" placeholder="Nombre del pictograma"></b-input>
              </b-field>
              <b-field :label="$t('order')">
                <b-input v-model="form.order_column" placeholder="Orden de visualización del pictograma" disabled></b-input>
              </b-field>
            </div>
          </div>
        </expandable-panel>

        <expandable-panel :item="_GetOptionsConfig('config_pictogram_resources')">
          <!-- <div class="flex flex-col space-y-2 sm:space-y-3">

            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
              <span class="text-sm text-gray-700 sm:ml-4 sm:text-right flex-shrink-0">
                <span class="font-medium text-gray-800">{{ $t('file') + ' original'}}</span>
              </span>
              <b-tooltip :label="$t('download_document')" position="is-top" v-if="form.document_id">
                <div class="cursor-pointer text-blue-light">
                    <a class="is-link" @click="downloadDoc(form.document_id)">
                        <span class="icon">
                          <i class="fas fa-file"></i>
                        </span>
                    </a>
                </div>
              </b-tooltip>
            </div>
          </div> -->


          <div class="flex flex-col space-y-4 px-2 py-1">

            <!-- Versión pendiente de confirmar -->
            <div v-if="pendingVersion" class="rounded-md border border-amber-300 bg-amber-50 p-3">
              <div class="flex items-start gap-2">
                <b-icon pack="fas" icon="clock" type="is-warning" custom-class="mt-0.5"></b-icon>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-semibold text-amber-900">
                    Versión pendiente de confirmar
                  </p>
                  <p class="text-xs text-amber-800 mt-1 truncate">
                    {{ pendingVersion.original_filename || 'Archivo DXF' }}
                    <template v-if="pendingVersion.user">
                      · subida por {{ pendingVersion.user.fullname || pendingVersion.user.name }}
                    </template>
                    <template v-if="pendingVersion.created_at">
                      · {{ _FormatDate(pendingVersion.created_at) }}
                    </template>
                  </p>
                  <p v-if="!pendingVersion.has_scene" class="text-xs text-red-700 mt-2 italic">
                    El scene parseado no está disponible. Tenés que descartar y volver a subir el DXF.
                  </p>
                </div>
              </div>
              <div class="flex justify-end gap-2 mt-3">
                <b-button
                  size="is-small"
                  type="is-danger"
                  outlined
                  icon-pack="fas"
                  icon-left="trash"
                  :loading="isDiscardingPending"
                  :disabled="isDiscardingPending"
                  @click="_OnClickDiscardPending"
                >
                  Descartar
                </b-button>
                <b-button
                  v-if="pendingVersion.has_scene"
                  size="is-small"
                  type="is-warning"
                  icon-pack="fas"
                  icon-left="arrow-right"
                  @click="_OnClickContinuePendingReview"
                >
                  Continuar revisión
                </b-button>
              </div>
            </div>

            <!-- Archivo activo -->
            <div v-if="activeVersion">
              <p class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-1">Archivo activo</p>
              <div class="flex items-center gap-2 px-3 py-2.5 rounded-md border border-blue-300 bg-blue-50 hover:bg-blue-100 transition-colors">
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2">
                    <b-icon pack="fas" icon="file" size="is-small" type="is-primary"></b-icon>
                    <span class="font-semibold text-sm truncate">{{ activeVersion.original_filename }}</span>
                    <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-bold uppercase bg-blue-500 text-white">
                      v{{ activeVersion.version_number }}
                    </span>
                  </div>
                  <p class="text-xs text-gray-500 mt-1">
                    <template v-if="activeVersion.created_at">
                      actualizado el {{ _FormatDate(activeVersion.created_at) }}
                    </template>
                    <template v-else>versión inicial</template>
                  </p>
                </div>
                <b-tooltip label="Descargar" position="is-left">
                  <button @click="_OnClickDownloadVersion(activeVersion)"
                          class="inline-flex items-center justify-center w-7 h-7 rounded text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors">
                    <b-icon pack="fas" icon="download" size="is-small"></b-icon>
                  </button>
                </b-tooltip>
              </div>
            </div>

            <!-- Versiones anteriores -->
            <div v-if="previousVersions.length > 0">
              <p class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-1">
                Versiones anteriores ({{ previousVersions.length }})
              </p>
              <div class="flex flex-col gap-1.5 max-h-60 overflow-y-auto pr-0.5 versions-scrollable">
                <div
                  v-for="version in previousVersions"
                  :key="version.id"
                  class="flex items-center gap-2 px-3 py-2 rounded-md border border-gray-200 bg-white hover:bg-gray-50 transition-colors text-sm"
                >
                  <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-2">
                      <b-icon pack="fas" icon="file" size="is-small" type="is-grey"></b-icon>
                      <span class="truncate">{{ version.original_filename }}</span>
                      <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-bold uppercase bg-gray-200 text-gray-600">
                        v{{ version.version_number }}
                      </span>
                    </div>
                    <p class="text-xs text-gray-500 mt-0.5">
                      {{ _FormatDate(version.created_at) }}
                      <template v-if="version.basic_info">
                        · {{ version.basic_info.fullname || version.basic_info.name || 'Usuario' }}
                      </template>
                    </p>
                  </div>
                  <div class="flex gap-1">
                    <b-tooltip label="Descargar" position="is-left">
                      <button @click="_OnClickDownloadVersion(version)"
                              class="inline-flex items-center justify-center w-7 h-7 rounded text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors">
                        <b-icon pack="fas" icon="download" size="is-small"></b-icon>
                      </button>
                    </b-tooltip>
                    <b-tooltip :label="_RestoreTooltipLabel(version)" position="is-left" multilined>
                      <button @click="_OnClickRestoreVersion(version)"
                              :disabled="!_CanRestoreVersion(version)"
                              class="inline-flex items-center justify-center w-7 h-7 rounded text-gray-500 hover:bg-amber-100 hover:text-amber-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent">
                        <b-icon pack="fas" icon="history" size="is-small"></b-icon>
                      </button>
                    </b-tooltip>
                    <b-tooltip :label="pendingVersion ? 'Resolvé la versión pendiente antes de eliminar' : 'Eliminar esta versión'" position="is-left" multilined>
                      <button @click="_OnClickDeleteVersion(version)"
                              :disabled="!!pendingVersion || isDeletingVersionId === version.id"
                              class="inline-flex items-center justify-center w-7 h-7 rounded text-gray-500 hover:bg-red-100 hover:text-red-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent">
                        <b-icon pack="fas" icon="trash" size="is-small"></b-icon>
                      </button>
                    </b-tooltip>
                  </div>
                </div>
              </div>
            </div>

            <!-- Estado vacío -->
            <div v-if="!activeVersion" class="text-sm text-gray-500 italic px-2">
              Este pictograma no tiene archivo DXF asociado.
            </div>

            <!-- Acción primaria -->
            <div v-if="activeVersion" class="pt-2 border-t border-gray-200">
              <b-tooltip
                v-if="!supportsDxfVersioning"
                label="Este pictograma fue creado antes del soporte de versionado de DXF. No se pueden subir versiones nuevas."
                position="is-top"
                multilined
              >
                <b-button type="is-primary" size="is-small" icon-pack="fas" icon-left="upload" expanded disabled>
                  Subir nueva versión del DXF
                </b-button>
              </b-tooltip>
              <b-tooltip
                v-else-if="pendingVersion"
                label="Hay una versión pendiente — confirmá o descartala antes de subir otra"
                position="is-top"
                multilined
              >
                <b-button type="is-primary" size="is-small" icon-pack="fas" icon-left="upload" expanded disabled>
                  Subir nueva versión del DXF
                </b-button>
              </b-tooltip>
              <b-button
                v-else
                type="is-primary"
                size="is-small"
                icon-pack="fas"
                icon-left="upload"
                expanded
                @click="_OnClickUploadNewVersion"
              >
                Subir nueva versión del DXF
              </b-button>
            </div>

            </div>
        </expandable-panel>

      </div>

      <!-- Columna derecha -->
      <div class="flex flex-col space-y-4">

        <expandable-panel :item="_GetOptionsConfig('config_pictogram_visibility')"
          mode="mixed"
          optionType="switch"
          :default-active="isPictogramVisible"
          @input="_handleMasterVisibilityToggle"
        >

        <div class="flex flex-col space-y-2 sm:space-y-3">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
              <span class="text-sm text-gray-700 sm:ml-4 sm:text-right flex-shrink-0">
                <span class="font-medium text-gray-800">{{ $t('visible_dashboard') }}</span>
              </span>
              <b-switch
                size="is-small"
                v-model="form.visible_dashboard"
                :disabled="!isPictogramVisible"
              />
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
              <span class="text-sm text-gray-700 sm:ml-4 sm:text-right flex-shrink-0">
                <span class="font-medium text-gray-800">{{ $t('visible_report') }}</span>
              </span>
              <b-switch
                size="is-small"
                v-model="form.visible_report"
                :disabled="!isPictogramVisible"
              />
            </div>
          </div>
        </expandable-panel>
      </div>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import axios from 'axios';

import ExpandablePanel from '../layer-statuses/expandable-panel.vue';
import { editPartialPictogram, getPendingVersion, discardPendingVersion, startRestoreFromVersion, deleteDocumentVersion } from '../../services/pictograms.service.js';

export default {
  name: 'PictogramConfig',

  components: {
    ExpandablePanel,
  },

  props: {
    entity: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      item: null,
      optionsConfig: null,
      isInitializing: true,

      pictogram: this.entity,

      saveConfigurationTimeout: null, // Timeout para debounce del guardado
      originalFormData: null, // Valores originales del formulario para comparar cambios

      form: new Form({
        name: null,
        code: null,
        order_column: 0,
        visible_dashboard: false,
        visible_report: false,
        document_id: null,
      }),

      pendingVersion:        null,
      isDiscardingPending:   false,
      isStartingRestore:     false,
      isDeletingVersionId:   null,
    }
  },

  created() {
    this.optionsConfig = this._getConfigOptions();
    this._initializeForm();
    // Marcar que la inicialización ha terminado y guardar valores originales
    this.$nextTick(() => {
      this.isInitializing = false;
      this.originalFormData = { ...this.form.data() };
    });
    this._LoadPendingVersion();
  },

  beforeDestroy() {
    // Limpiar el timeout al destruir el componente para evitar memory leaks
    if (this.saveConfigurationTimeout) {
      clearTimeout(this.saveConfigurationTimeout);
      this.saveConfigurationTimeout = null;
    }
  },

  computed: {
    formData() {
      // Computed property que devuelve los datos del formulario
      // Esto permite observar todos los cambios de una vez
      return this.form.data();
    },

    // Derivado de los switches hijos de visibilidad
    // true si CUALQUIER propiedad de visibilidad está activa
    isPictogramVisible() {
      return !!this.form.visible_dashboard || !!this.form.visible_report;
    },

    documentVersions() {
      const versions = this.pictogram?.document?.versions ?? [];
      return versions.map((v, idx, arr) => ({
        ...v,
        version_number: arr.length - idx,  // versions[0] es la más reciente de las anteriores
      }));
    },

    activeVersion() {
      if (!this.pictogram?.document) return null;

      // El archivo activo vive en la raíz del bucket — corresponde al Document
      // principal, no a una DocumentVersion (esas son las anteriores).
      return {
        id: null,  // no hay DocumentVersion para la activa
        version_number: this.documentVersions.length + 1,
        original_filename: this.pictogram.document.original_filename,
        created_at: this.pictogram.document.updated_at ?? this.pictogram.document.created_at,
        basic_info: null,  // el backend no expone quién la subió en este shape
        isActiveDocument: true,
      };
    },

    previousVersions() {
      return this.documentVersions;
    },

    // Bool del shape del backend — true solo para pictogramas creados a partir
    // del deploy de versionado de DXF. Los pre-deploy (legacy) no soportan
    // subir nuevas versiones ni restore.
    supportsDxfVersioning() {
      return !!this.pictogram?.supports_dxf_versioning;
    },
  },

  watch: {
    formData: {
      handler() {
        if (!this.isInitializing) {
          this._debouncedSaveConfiguration();
        }
      },
      deep: true
    }
  },

  methods: {
    _getConfigOptions() {
      return [
        {
          code: 'config_pictogram_specifications',
          name: 'Especificaciones del pictograma',
          description: 'Gestión de nombre, codigo, descripción, visibilidad del pictograma.',
          icon: 'cog',
          order: 0,
          type: 'item',
        },
        {
          code: 'config_pictogram_resources',
          name: 'Recursos del pictograma',
          description: "Gestión de recursos del pictograma, como imágenes, videos, documentos, etc.",
          icon: 'file-alt',
          order: 1,
          type: 'item',
        },
        {
          code: 'config_pictogram_visibility',
          name: 'Visibilidad del pictograma',
          description: "Gestión de visibilidad del pictograma, como visible en el dashboard, etc.",
          icon: 'eye',
          order: 2,
          type: 'item',
        },
      ]
    },

    _GetOptionsConfig(code) {
      return this.optionsConfig.find(option => option.code === code);
    },

    _initializeForm() {
      this.form.code = this.pictogram.code;
      this.form.name = this.pictogram.name;
      this.form.order_column = this.pictogram.order_column;
      this.form.visible_dashboard = !!this.pictogram.visible_dashboard;
      this.form.visible_report = !!this.pictogram.visible_report;
      this.form.document_id = this.pictogram.document_id;
    },

    // Interruptor maestro de visibilidad
    // Al apagar: desactiva todos los switches hijos
    // Al encender: activa visible_dashboard por defecto
    _handleMasterVisibilityToggle(value) {
      if (!value) {
        this.form.visible_dashboard = false;
        this.form.visible_report = false;
      } else {
        this.form.visible_dashboard = true;
        this.form.visible_report = true;
      }
    },

    /**
     * Debounce para el guardado de configuración
     * Espera 800ms después del último cambio antes de ejecutar el guardado
     * Esto permite que el usuario configure múltiples opciones sin disparar múltiples guardados
     */
     _debouncedSaveConfiguration() {
      // Limpiar el timeout anterior si existe
      if (this.saveConfigurationTimeout) {
        clearTimeout(this.saveConfigurationTimeout);
      }

      // Establecer nuevo timeout (800ms es un tiempo estándar para formularios de configuración)
      this.saveConfigurationTimeout = setTimeout(() => {
        this._saveConfiguration();
        this.saveConfigurationTimeout = null;
      }, 800);
    },

    /**
     * Compara los valores actuales del formulario con los originales
     * y retorna solo los campos que han cambiado
     * @param {Object} currentData - Datos actuales del formulario
     * @param {Object} originalData - Datos originales del formulario
     * @returns {Object} Objeto con solo los campos que cambiaron
     */
    _getChangedFields(currentData, originalData) {
      if (!originalData) return currentData;

      const changedFields = {};

      Object.keys(currentData).forEach(key => {
        const currentValue = currentData[key];
        const originalValue = originalData[key];

        // Comparar valores (considerando null, undefined, y tipos)
        if (JSON.stringify(currentValue) !== JSON.stringify(originalValue)) {
          changedFields[key] = currentValue;
        }
      });

      return changedFields;
    },

    async _saveConfiguration() {
      // console.log('=== Formulario - Claves y Valores ===');

      // Obtener los datos del formulario
      const formData = this.form.data();

      // Obtener solo los campos que han cambiado
      const changedFields = this._getChangedFields(formData, this.originalFormData);

      // Si no hay cambios, no enviar nada
      if (Object.keys(changedFields).length === 0) {
        return;
      }

      // Listar todas las claves y valores
      // Object.keys(formData).forEach(key => {
      //   console.log(`${key}:`, formData[key]);
      // });

      // console.log('changedFields: ', changedFields);

      // Construir payload solo con los campos que cambiaron
      const payload = {
        data: {
          ...changedFields,
        },
      };

      try {
        const response = await editPartialPictogram(this.pictogram.id, payload);

        if( response.success ) {
          // Actualizar los valores originales después de guardar exitosamente
          this.originalFormData = { ...this.form.data() };

          this.$toast.open({
            message: this.$t("assignment_update_success"),
            type: "is-success",
            position: "is-top-right",
          });

          // Nombre/visibilidad del pictograma no afectan al progreso → parche in-place
          // sin re-fetch ni reset de navegación.
          this.$emit('epc-pictograms-reload', {
            scope: 'pictogram',
            changes: changedFields,
            affectsProgress: false,
          })

        } else {
          this.$toast.open({
            message: response.error,
            type: "is-danger",
            position: "is-top-right",
          });
        }
      } catch (error) {
        console.error("Error al guardar datos de las capas del pictograma:", error);
        this.$toast.open({
          message: error.error_msg || this.$t("assignment_update_error"),
          type: "is-danger",
          position: "is-top-right",
        });
      } finally {

      }
    },

    async downloadDoc(document_id) {
      this.$notify.success("starting_download_document");
      let url = "/api/v2/document/" + document_id;

      const {data} = await axios.get(url);

      if (data) {
        window.open(data.data);
      } else {
        this.$notify.error("error_download_document");
      }
    },

    async downloadDocVersion(versionId) {
      this.$notify.success('starting_download_document');
      const url = '/api/v2/document/version/' + versionId;
      try {
        const { data } = await axios.get(url);
        if (data) {
          window.open(data.data);
        } else {
          this.$notify.error('error_download_document');
        }
      } catch (err) {
        this.$notify.error('error_download_document');
      }
    },

    _OnClickDownloadVersion(version) {
      if (version.isActiveDocument) {
        this.downloadDoc(this.pictogram.document_id);
      } else {
        this.downloadDocVersion(version.id);
      }
    },

    _CanRestoreVersion(version) {
      return this.supportsDxfVersioning
        && !this.pendingVersion
        && !this.isStartingRestore
        && version.has_scene_snapshot !== false;  // null/true => permitido
    },

    _RestoreTooltipLabel(version) {
      if (!this.supportsDxfVersioning) {
        return 'Este pictograma fue creado antes del soporte de versionado de DXF.';
      }
      if (this.pendingVersion)            return 'Resolvé la versión pendiente antes de restaurar';
      if (version.has_scene_snapshot === false) {
        return 'Esta versión no se puede restaurar — fue subida antes del registro por versión. Podés eliminarla.';
      }
      return 'Restaurar esta versión';
    },

    _OnClickDeleteVersion(version) {
      if (this.pendingVersion) {
        this.$toast.open({
          message:  'Hay una versión pendiente de confirmar. Resolvela antes de eliminar versiones.',
          type:     'is-warning',
          position: 'is-top-right',
        });
        return;
      }

      this.$buefy.dialog.confirm({
        title:        'Eliminar versión',
        message:      `¿Eliminar definitivamente la versión v${version.version_number} (${version.original_filename || 'archivo DXF'})? Se borrará el DXF y el scene snapshot si existe. Esta acción no se puede deshacer.`,
        confirmText:  'Eliminar',
        cancelText:   'Cancelar',
        type:         'is-danger',
        hasIcon:      true,
        onConfirm: async () => {
          this.isDeletingVersionId = version.id;
          try {
            const res = await deleteDocumentVersion(this.pictogram.id, version.id);
            if (!res?.success) {
              throw new Error(res?.error_msg || res?.message || 'delete_failed');
            }
            this.$toast.open({
              message:  `Versión v${version.version_number} eliminada`,
              type:     'is-success',
              position: 'is-top-right',
            });
            // Cambia la versión DXF activa (geometría/capas) → refresh dirigido.
            this.$emit('epc-pictograms-reload', { scope: 'pictogram', affectsProgress: true });
          } catch (err) {
            console.error('Error eliminando versión:', err);
            this.$toast.open({
              message:  err.error_msg || err.message || 'No se pudo eliminar la versión.',
              type:     'is-danger',
              position: 'is-top-right',
            });
          } finally {
            this.isDeletingVersionId = null;
          }
        },
      });
    },

    _OnClickRestoreVersion(version) {
      // Bloqueado si hay una versión pendiente — single-mode
      if (this.pendingVersion) {
        this.$toast.open({
          message:  'Hay una versión pendiente de confirmar. Descártala o confírmala antes de restaurar.',
          type:     'is-warning',
          position: 'is-top-right',
        });
        return;
      }

      this.$buefy.dialog.confirm({
        title:        'Restaurar versión',
        message:      `¿Querés restaurar la versión v${version.version_number} (${version.original_filename || 'archivo DXF'})? Se va a crear una nueva versión con este contenido. Vas a poder revisar los cambios antes de confirmar.`,
        confirmText:  'Continuar',
        cancelText:   'Cancelar',
        type:         'is-warning',
        hasIcon:      true,
        onConfirm: async () => {
          this.isStartingRestore = true;
          const loading = this.$buefy.loading.open({ container: null });
          try {
            const res = await startRestoreFromVersion(this.pictogram.id, version.id);
            if (!res?.success) {
              throw new Error(res?.error_msg || res?.message || 'restore_failed');
            }
            this.$router.push({
              name: 'project.admin.pictogram.process-update',
              params: {
                project_id: this.pictogram.project_id,
                id:         this.pictogram.id,
              },
              query: {
                temp_key:       res.scene_temp_key,
                doc_version_id: res.document_version_id,
              },
            });
          } catch (err) {
            console.error('Error iniciando restauración:', err);
            this.$toast.open({
              message:  err.error_msg || err.message || 'No se pudo iniciar la restauración.',
              type:     'is-danger',
              position: 'is-top-right',
            });
          } finally {
            this.isStartingRestore = false;
            loading.close();
          }
        },
      });
    },

    _OnClickUploadNewVersion() {
      this.$router.push({
        name: 'project.admin.pictogram.process-update',
        params: {
          project_id: this.pictogram.project_id,
          id: this.pictogram.id,
        },
      });
    },

    async _LoadPendingVersion() {
      try {
        const res = await getPendingVersion(this.pictogram.id);
        this.pendingVersion = res?.pending ?? null;
      } catch (err) {
        // Silencioso — el banner es informativo, no romper la página si falla.
        console.error('Error cargando versión pendiente:', err);
        this.pendingVersion = null;
      }
    },

    _OnClickContinuePendingReview() {
      if (!this.pendingVersion?.has_scene) return;
      this.$router.push({
        name: 'project.admin.pictogram.process-update',
        params: {
          project_id: this.pictogram.project_id,
          id:         this.pictogram.id,
        },
        query: {
          temp_key:       this.pendingVersion.scene_temp_key,
          doc_version_id: this.pendingVersion.document_version_id,
        },
      });
    },

    _OnClickDiscardPending() {
      this.$buefy.dialog.confirm({
        title:        'Descartar versión pendiente',
        message:      '¿Seguro que querés descartar la versión pendiente? Se borrarán el DXF y el scene parseado. Esta acción no se puede deshacer.',
        confirmText:  'Descartar',
        cancelText:   'Cancelar',
        type:         'is-danger',
        hasIcon:      true,
        onConfirm: async () => {
          this.isDiscardingPending = true;
          try {
            const res = await discardPendingVersion(this.pictogram.id);
            if (res?.success) {
              this.$toast.open({
                message:  'Versión pendiente descartada',
                type:     'is-success',
                position: 'is-top-right',
              });
              this.pendingVersion = null;
              // Descartar la versión pendiente puede alterar geometría/capas → refresh dirigido.
              this.$emit('epc-pictograms-reload', { scope: 'pictogram', affectsProgress: true });
            } else {
              this.$toast.open({
                message:  res?.error_msg || 'No se pudo descartar la versión.',
                type:     'is-danger',
                position: 'is-top-right',
              });
            }
          } catch (err) {
            console.error('Error descartando versión pendiente:', err);
            this.$toast.open({
              message:  err.error_msg || err.message || 'Error al descartar.',
              type:     'is-danger',
              position: 'is-top-right',
            });
          } finally {
            this.isDiscardingPending = false;
          }
        },
      });
    },

    _FormatDate(dateStr) {
      if (!dateStr) return '';
      try {
        return new Date(dateStr).toLocaleDateString('es-ES', {
          day: '2-digit', month: 'short', year: 'numeric',
        });
      } catch {
        return dateStr;
      }
    },
  }
}
</script>

<style scoped>
  /* Tailwind no expone pseudo-elements de scrollbar — necesitamos CSS aparte */
  .versions-scrollable::-webkit-scrollbar {
    width: 5px;
  }

  .versions-scrollable::-webkit-scrollbar-track {
    background: transparent;
  }

  .versions-scrollable::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  .versions-scrollable::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
</style>
